module.exports = __webpack_public_path__ + "static/media/eg2.d03a6716.webp";